import React, { useEffect, useState } from 'react';
import Poster2023 from '../../Assets/Internships/InternshipLegacy/2023.png';
import Poster2024 from '../../Assets/Internships/InternshipLegacy/2024.jpg';
import Poster2025 from '../../Assets/Internships/InternshipLegacy/2025.jpg';
import Poster2026 from '../../Assets/Internships/internship-2026.jpg';
import '../../Styles/InternshipProgram.css';


const posterImages = [
  { year: '2026', src: Poster2026 },
  { year: '2025', src: Poster2025 },
  { year: '2024', src: Poster2024 },
  { year: '2023', src: Poster2023 },
];

const LegacySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(
      () => setCurrentIndex((current) => (current + 1) % posterImages.length),
      3000,
    );
    return () => window.clearInterval(interval);
  }, []);

  const visiblePosters = Array.from(
    { length: 3 },
    (_, offset) => posterImages[(currentIndex + offset) % posterImages.length],
  );

  return (
    <div className="internship-legacy-section">
      <div className="internship-legacy-inner">
        <header>
          <p className="section-eyebrow">OUR JOURNEY</p>
          <h2>Our Legacy</h2>
          <div className="internship-title-line" aria-hidden="true" />
        </header>

        <div className="internship-legacy-slider">
          <button
            type="button"
            className="internship-legacy-arrow previous"
            aria-label="Show previous internship posters"
            onClick={() => setCurrentIndex((current) => (current - 1 + posterImages.length) % posterImages.length)}
          >
            ‹
          </button>
          <div className="internship-legacy-track">
            {visiblePosters.map((poster, index) => (
              <figure key={`${poster.year}-${index}`}>
                <img src={poster.src} alt={`NCGSA Internship Program ${poster.year} poster`} loading="lazy" />
                <figcaption>{poster.year}</figcaption>
              </figure>
            ))}
          </div>
          <button
            type="button"
            className="internship-legacy-arrow forward"
            aria-label="Show next internship posters"
            onClick={() => setCurrentIndex((current) => (current + 1) % posterImages.length)}
          >
            ›
          </button>
        </div>

        <div className="internship-legacy-dots" aria-label="Select poster">
          {posterImages.map((poster, index) => (
            <button
              type="button"
              key={poster.src}
              className={index === currentIndex ? 'active' : ''}
              aria-label={`Show ${poster.year} poster first`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegacySection;
